const firebaseConfig = {
    apiKey: "AIzaSyAjkXxJNCl6bfyHPs_amWDwi--nng9AZ_k",
    authDomain: "travel-guru-c1cf9.firebaseapp.com",
    databaseURL: "https://travel-guru-c1cf9.firebaseio.com",
    projectId: "travel-guru-c1cf9",
    storageBucket: "travel-guru-c1cf9.appspot.com",
    messagingSenderId: "161087734777",
    appId: "1:161087734777:web:fef0b858c176d52e0c7328"
  };

  export default firebaseConfig;